export const SHOPIFY_INSTALL_PARAM = 'shop';

export const normalizeShopifyShop = shop => {
  if (!shop || typeof shop !== 'string') {
    return null;
  }

  const trimmedShop = shop.trim().toLowerCase();
  const withoutProtocol = trimmedShop.replace(/^https?:\/\//, '');
  const hostname = withoutProtocol.split('/')[0].split('?')[0];

  return /^[a-z0-9-]+\.myshopify\.com$/.test(hostname) ? hostname : null;
};

export const shopifyInstallPath = shop => {
  const normalizedShop = normalizeShopifyShop(shop);
  return normalizedShop
    ? `/store-settings?${new URLSearchParams({ [SHOPIFY_INSTALL_PARAM]: normalizedShop })}`
    : null;
};
